import { Grid, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { LayoutBackground} from '../../components/Layout/LayoutBackground/LayoutBackground.component';
import { Prompt } from '../../components/Prompt/Prompt.component';
import { AddUserPassword } from '../../components/addUser/AddPassword.component';
import { useHistory } from 'react-router-dom';
import { verifyUserToken } from '../../services/users/users.service';
import { useParams } from 'react-router-dom';
import { TokenResponse } from '../EmailActivation/TokenResponse.types';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';
import { useTranslation } from 'react-i18next';

export const AccountActivation: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const [isAccountConfirmationPromptVisible, setIsAccountConfirmationPromptVisible] = useState<boolean>(false);
  const [isErrorPromptVisible, setIsErrorPromptVisible] = useState<boolean>(false);
  const [isLinkExpiredPromptVisible, setIsLinkExpiredPromptVisible] = useState<boolean>(false);
  const [isLinkAlreadyUsedPromptVisible, setIsLinkAlreadyUsedPromptVisible] = useState<boolean>(false);

  const [openAddUserPassword, setOpenAddUserPassword] = useState<boolean>(false);

  useDocumentTitle('Potwierdź konto');

  const { token, email } = useParams() as {
    token: string;
    email: string;
  };

  const handleVerifyToken = () => {
    verifyUserToken(token).then(
      (res: TokenResponse) => {
        switch (res) {
          case TokenResponse.Valid:
            setIsAccountConfirmationPromptVisible(true);
            break;
          case TokenResponse.Expired:
            setIsLinkExpiredPromptVisible(true);
            break;
          case TokenResponse.NotExist:
            setIsLinkAlreadyUsedPromptVisible(true);
            break;
        }
      },
      () => {
        setIsErrorPromptVisible(true);
      },
    );
  };

  useEffect(() => {
    handleVerifyToken();
  }, [token, email]);

  const handleOpenAddUserPassword = () => {
    setIsAccountConfirmationPromptVisible(false);
    setOpenAddUserPassword(true);
  };

  const handleAddUserPasswordClose = () => {
    setOpenAddUserPassword(false);
  };

  useEffect(() => {
    if (isLinkAlreadyUsedPromptVisible || isLinkExpiredPromptVisible || isErrorPromptVisible) {
      setTimeout(() => {
        history.push('/');
      }, 10000);
    }
  }, [isLinkAlreadyUsedPromptVisible, isLinkExpiredPromptVisible, isErrorPromptVisible]);

  useEffect(() => {
    if (isAccountConfirmationPromptVisible) {
      setTimeout(() => {
        setIsAccountConfirmationPromptVisible(false);
        setOpenAddUserPassword(true);
      }, 10000);
    }
  }, [isAccountConfirmationPromptVisible]);

  const SuccessPromptSubText = () => {
    return (
      <Grid item xs={11}>
        <Typography
          variant="body1"
          style={{
            fontWeight: 400,
            fontSize: '15px',
            paddingBottom: '20px',
            lineHeight: 2,
          }}
        >
          Za chwilę automatycznie zostaniesz przekierowany/na do ekranu ustawiania hasła. Jeśli przekierowanie nie
          nastąpi automatycznie, kliknij w poniższy przycisk.
        </Typography>
      </Grid>
    );
  };

  const SuccessErrorExpiredPromptSubText = () => {
    return (
      <Grid item xs={11}>
        <Typography
          variant="body1"
          style={{
            fontWeight: 400,
            fontSize: '15px',
            paddingBottom: '20px',
            lineHeight: 2,
          }}
        >
          Za chwilę automatycznie zostaniesz przekierowany/na do ekranu logowania. Jeśli przekierowanie nie nastąpi
          automatycznie kliknij w poniższy przycisk.
        </Typography>
      </Grid>
    );
  };

  const logout = () => {
    history.push('/');
  };

  return (
    <>
      <LayoutBackground />
      {isLinkExpiredPromptVisible && (
        <Prompt
          type="expired link"
          open={isLinkExpiredPromptVisible}
          isBold={true}
          size="xs"
          mainText={'Twój link stracił ważność.'}
          enhancedText={<SuccessErrorExpiredPromptSubText />}
          mainActionButtonText={'Powrót do logowania'}
          onConfirm={logout}
          isRemovedBackdrop={true}
        />
      )}
      {isLinkAlreadyUsedPromptVisible && (
        <Prompt
          type="link already used"
          open={isLinkAlreadyUsedPromptVisible}
          isBold={true}
          size="xs"
          mainText={'Link aktywacyjny został już wykorzystany.'}
          enhancedText={<SuccessErrorExpiredPromptSubText />}
          mainActionButtonText={'Powrót do logowania'}
          onConfirm={logout}
          isRemovedBackdrop={true}
        />
      )}
      {isAccountConfirmationPromptVisible && (
        <Prompt
          type="success"
          open={isAccountConfirmationPromptVisible}
          isBold={true}
          size="xs"
          enhancedText={<SuccessPromptSubText />}
          mainActionButtonText={`Ustaw hasło w ${t('global:shortNames.system')}`}
          onConfirm={handleOpenAddUserPassword}
          isRemovedBackdrop={true}
        />
      )}
      {isErrorPromptVisible && (
        <Prompt
          type="error"
          open={isErrorPromptVisible}
          isBold={true}
          size="xs"
          mainText={'Aktywacja konta nie powiodła się, spróbuj ponownie później.'}
          enhancedText={<SuccessErrorExpiredPromptSubText />}
          mainActionButtonText={'Powrót do logowania'}
          onConfirm={logout}
          isRemovedBackdrop={true}
        />
      )}
      {openAddUserPassword && (
        <AddUserPassword
          open={openAddUserPassword}
          token={token}
          email={atob(email)}
          onClose={handleAddUserPasswordClose}
        />
      )}
    </>
  );
};
